var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
var CUTOFF_TIME = 12;

function setDeliveryTime() {
    var curTime = new Date();
    var cutoffTime = new Date();
    if (curTime.getUTCHours() >= CUTOFF_TIME) {
        cutoffTime.setUTCDate(cutoffTime.getUTCDate() + 1);
    }
    cutoffTime.setUTCHours(CUTOFF_TIME);
    cutoffTime.setUTCMinutes(0);
    cutoffTime.setUTCSeconds(0);
    var timeLeft = Math.floor((cutoffTime - curTime) / 1000);
    var hours = parseInt(timeLeft / 3600) % 24;
    var minutes = parseInt(timeLeft / 60) % 60;
    var seconds = timeLeft % 60;
    var hourstring = hours > 1 ? 'hrs ' : 'hr ';
    var minstring = minutes > 1 ? 'mins ' : 'min ';
    var secondstring = seconds > 1 ? 'secs ' : 'sec'
    $('.timeleft-button').html(hours + hourstring + minutes + minstring + seconds + secondstring);
    var standardDate = new Date(cutoffTime.getTime());
    var priorityDate = new Date(cutoffTime.getTime());
    var sstandardDate = new Date(cutoffTime.getTime());
      var prodstandardDate = new Date(cutoffTime.getTime());
      var prodpriorityDate = new Date(cutoffTime.getTime());
// Paul added 3 days to everthing
    var orderDay = cutoffTime.getDay();
    switch (orderDay) {
        case 0: // Sunday
            standardDate.setUTCDate(standardDate.getUTCDate() + 15);
            sstandardDate.setUTCDate(sstandardDate.getUTCDate() + 13);
            priorityDate.setUTCDate(priorityDate.getUTCDate() + 3);
          prodpriorityDate.setUTCDate(prodpriorityDate.getUTCDate() + 3);
          prodstandardDate.setUTCDate(prodstandardDate.getUTCDate() + 4);
            break;
        case 1: // Monday
            standardDate.setUTCDate(standardDate.getUTCDate() + 14);
            sstandardDate.setUTCDate(sstandardDate.getUTCDate() + 12);
            priorityDate.setUTCDate(priorityDate.getUTCDate() + 2);
          prodpriorityDate.setUTCDate(prodpriorityDate.getUTCDate() + 2);
          prodstandardDate.setUTCDate(prodstandardDate.getUTCDate() + 3);
            break;
        case 2: // Tuesday
            standardDate.setUTCDate(standardDate.getUTCDate() + 14);
            sstandardDate.setUTCDate(sstandardDate.getUTCDate() + 12);
            priorityDate.setUTCDate(priorityDate.getUTCDate() + 2);
          prodpriorityDate.setUTCDate(prodpriorityDate.getUTCDate() + 2);
          prodstandardDate.setUTCDate(prodstandardDate.getUTCDate() + 3);
            break;
        case 3: // Wednesday
            standardDate.setUTCDate(standardDate.getUTCDate() + 14);
            sstandardDate.setUTCDate(sstandardDate.getUTCDate() + 12);
            priorityDate.setUTCDate(priorityDate.getUTCDate() + 2);
          prodpriorityDate.setUTCDate(prodpriorityDate.getUTCDate() + 2);
          prodstandardDate.setUTCDate(prodstandardDate.getUTCDate() + 5);
            break;
        case 4: // Thursday
            standardDate.setUTCDate(standardDate.getUTCDate() + 14);
            sstandardDate.setUTCDate(sstandardDate.getUTCDate() + 12);
            priorityDate.setUTCDate(priorityDate.getUTCDate() + 2);
          prodpriorityDate.setUTCDate(prodpriorityDate.getUTCDate() + 4);
          prodstandardDate.setUTCDate(prodstandardDate.getUTCDate() + 4);
            break;
        case 5: // Friday
            standardDate.setUTCDate(standardDate.getUTCDate() + 17);
            sstandardDate.setUTCDate(sstandardDate.getUTCDate() + 12);
            priorityDate.setUTCDate(priorityDate.getUTCDate() + 4);
          prodpriorityDate.setUTCDate(prodpriorityDate.getUTCDate() + 4);
          prodstandardDate.setUTCDate(prodstandardDate.getUTCDate() + 5);        
        
            break;
        case 6: // Saturday
            standardDate.setUTCDate(standardDate.getUTCDate() + 16);
            sstandardDate.setUTCDate(sstandardDate.getUTCDate() + 13);
            priorityDate.setUTCDate(priorityDate.getUTCDate() + 3);
          prodpriorityDate.setUTCDate(prodpriorityDate.getUTCDate() + 2);
          prodstandardDate.setUTCDate(prodstandardDate.getUTCDate() + 6);        
            break;
    }
    $('#standard_delivery').html(getFormattedDate(standardDate));
    $('#priority_delivery').html(getFormattedDate(priorityDate));
    $('#sstandard_delivery').html(getFormattedDate(sstandardDate));
     $('#prodstandard_delivery').html(getFormattedDate(prodstandardDate));
     $('#prodpriority_delivery').html(getFormattedDate(prodpriorityDate));
}
function getFormattedDate(date) {
    var str = '';
    str += DAYS[date.getUTCDay()] + ' ';
    str += ordinal_suffix_of(date.getUTCDate()) + ' ';
    str += MONTHS[date.getUTCMonth()];
    return str;
}
function ordinal_suffix_of(i) {
    var j = i % 10,
        k = i % 100;
    if (j == 1 && k != 11) {
        return i + "st";
    }
    if (j == 2 && k != 12) {
        return i + "nd";
    }
    if (j == 3 && k != 13) {
        return i + "rd";
    }
    return i + "th";
}

$(document).ready(function() {

  	setDeliveryTime();
    setInterval(setDeliveryTime, 1000);
  
	// Initialize Masonry
	$('#content').masonry({
		columnWidth: 320,
		itemSelector: '.item',
		isFitWidth: true,
		isAnimated: !Modernizr.csstransitions
	}).imagesLoaded(function() {
		$(this).masonry('reload');
	});

});